export default {
  "admin.faqTab.searchPlaceholder": "Search FAQ items...",
  "admin.faqTab.allCategories": "All Categories",
  "admin.faqTab.allStatuses": "All Statuses",
  "admin.faqTab.active": "Active",
  "admin.faqTab.inactive": "Inactive",
  "admin.faqTab.clear": "Clear",
  "admin.faqTab.newFAQ": "Add New FAQ",
  "admin.faqTab.editFAQ": "Edit FAQ",
  "admin.faqTab.saveChanges": "Save Changes",
  "admin.faqTab.createItem": "Create Item",
  "admin.faqTab.cancel": "Cancel",
  "admin.faqTab.category": "Category",
  "admin.faqTab.sortOrder": "Sort Order",
  "admin.faqTab.status": "Status",
  "admin.faqTab.question": "Question",
  "admin.faqTab.answer": "Answer",
  "admin.faqTab.questionRequired": "Question and answer are required.",
  "admin.faqTab.saveFailed": "Save failed",
  "admin.faqTab.deleteFailed": "Delete failed",
  "admin.faqTab.deleteConfirm": "Are you sure you want to permanently delete this FAQ item?",
  "admin.faqTab.items_one": "item",
  "admin.faqTab.items_other": "items",
  "admin.faqTab.add": "Add",
  "admin.faqTab.loading": "Loading FAQ items...",
  "admin.faqTab.noMatch": "No FAQ items match the filters.",
  "admin.faqTab.noCategoryItems": "No FAQ items in this category yet.",
  "admin.faqTab.addOne": "Add one",
  "admin.faqTab.activate": "Activate",
  "admin.faqTab.deactivate": "Deactivate",
  "admin.faqTab.edit": "Edit",
  "admin.faqTab.delete": "Delete",
  "admin.faqTab.cat.0": "Company Formation",
  "admin.faqTab.cat.1": "Visa & Immigration",
  "admin.faqTab.cat.2": "Business Expansion",
  "admin.faqTab.cat.3": "Platform & Partnership",
  "admin.faqTab.cat.4": "LegalTech & AI",
  "admin.faqTab.cat.5": "Compliance & Data Privacy",

  "admin.partnersTab.searchPlaceholder": "Search partners...",
  "admin.partnersTab.allCountries": "All Countries",
  "admin.partnersTab.allPracticeAreas": "All Practice Areas",
  "admin.partnersTab.clear": "Clear",
  "admin.partnersTab.newPartner": "New Partner",
  "admin.partnersTab.editPartner": "Edit Partner",
  "admin.partnersTab.createPartner": "Create Partner",
  "admin.partnersTab.cancel": "Cancel",
  "admin.partnersTab.saveChanges": "Save Changes",
  "admin.partnersTab.name": "Firm Name",
  "admin.partnersTab.rating": "Rating",
  "admin.partnersTab.country": "Country",
  "admin.partnersTab.city": "City",
  "admin.partnersTab.flag": "Flag Emoji",
  "admin.partnersTab.website": "Website",
  "admin.partnersTab.status": "Status",
  "admin.partnersTab.practiceAreas": "Practice Areas",
  "admin.partnersTab.description": "Description",
  "admin.partnersTab.requiredFields": "Firm name, country, and city are required.",
  "admin.partnersTab.saveFailed": "Save failed",
  "admin.partnersTab.deleteFailed": "Delete failed",
  "admin.partnersTab.deleteConfirm": "Are you sure you want to permanently delete this partner?",
  "admin.partnersTab.loading": "Loading partners...",
  "admin.partnersTab.noMatch": "No partners match the filters.",
  "admin.partnersTab.noPartners": "No partners yet.",
  "admin.partnersTab.edit": "Edit",
  "admin.partnersTab.delete": "Delete",
  "admin.partnersTab.active": "Active",
  "admin.partnersTab.inactive": "Inactive",
  "admin.partnersTab.firm": "Firm",
  "admin.partnersTab.location": "Location",
  "admin.partnersTab.actions": "Actions",

  "admin.testimonialsTab.searchPlaceholder": "Search testimonials...",
  "admin.testimonialsTab.allStatuses": "All Statuses",
  "admin.testimonialsTab.active": "Active",
  "admin.testimonialsTab.inactive": "Inactive",
  "admin.testimonialsTab.clear": "Clear",
  "admin.testimonialsTab.newTestimonial": "New Testimonial",
  "admin.testimonialsTab.editTestimonial": "Edit Testimonial",
  "admin.testimonialsTab.saveChanges": "Save Changes",
  "admin.testimonialsTab.create": "Create Testimonial",
  "admin.testimonialsTab.cancel": "Cancel",
  "admin.testimonialsTab.quote": "Quote",
  "admin.testimonialsTab.quoteRequired": "Quote *",
  "admin.testimonialsTab.name": "Name",
  "admin.testimonialsTab.nameRequired": "Name *",
  "admin.testimonialsTab.role": "Title",
  "admin.testimonialsTab.company": "Company",
  "admin.testimonialsTab.sortOrder": "Sort Order",
  "admin.testimonialsTab.status": "Status",
  "admin.testimonialsTab.avatarUrl": "Avatar URL",
  "admin.testimonialsTab.preview": "Preview",
  "admin.testimonialsTab.order": "Order",
  "admin.testimonialsTab.actions": "Action",
  "admin.testimonialsTab.edit": "Edit",
  "admin.testimonialsTab.delete": "Delete",
  "admin.testimonialsTab.requiredFields": "Quote and name are required.",
  "admin.testimonialsTab.saveFailed": "Save failed",
  "admin.testimonialsTab.deleteFailed": "Delete failed",
  "admin.testimonialsTab.loadFailed": "Failed to load testimonials",
  "admin.testimonialsTab.deleteConfirm": "Permanently delete this testimonial?",
  "admin.testimonialsTab.loading": "Loading testimonials...",
  "admin.testimonialsTab.noItems": "No testimonials yet.",
  "admin.testimonialsTab.retry": "Try Again",
  "admin.testimonialsTab.saving": "Saving...",
  "admin.testimonialsTab.unknownError": "Unknown error",

  "admin.pageBuilder.title": "Page Builder",
  "admin.pageBuilder.builderOn": "Builder On",
  "admin.pageBuilder.builderOff": "Builder Off",
  "admin.pageBuilder.published": "Published",
  "admin.pageBuilder.draft": "Draft",
  "admin.pageBuilder.save": "Save",
  "admin.pageBuilder.saving": "Saving...",
  "admin.pageBuilder.saved": "Saved!",
  "admin.pageBuilder.pages": "Pages",
  "admin.pageBuilder.sectionOrder": "Section Order",
  "admin.pageBuilder.dragHint": "Drag and drop to reorder",
  "admin.pageBuilder.selectPage": "Select a page from the left",
  "admin.pageBuilder.noPages": "No page schemas yet",
  "admin.pageBuilder.noPagesDesc": "No page_schema records found in the database. Create page schemas first.",
  "admin.pageBuilder.jsonPreview": "JSON Preview",
  "admin.pageBuilder.variant": "Variant",
  "admin.pageBuilder.loading": "Loading page schemas...",

  "admin.jurisdictions.loadFailed": "Load failed",
  "admin.jurisdictions.loading": "Loading jurisdictions...",
  "admin.jurisdictions.retry": "Try Again",
  "admin.jurisdictions.search": "Search jurisdictions...",
  "admin.jurisdictions.count": "jurisdictions",
  "admin.jurisdictions.add": "Add Jurisdiction",
  "admin.jurisdictions.popular": "Popular",
  "admin.jurisdictions.inactive": "Inactive",
  "admin.jurisdictions.edit": "Edit",
  "admin.jurisdictions.makePopular": "Make Popular",
  "admin.jurisdictions.removePopular": "Remove Popular",
  "admin.jurisdictions.activate": "Activate",
  "admin.jurisdictions.deactivate": "Deactivate",
  "admin.jurisdictions.saveFailed": "Save failed",
  "admin.jurisdictions.deleteFailed": "Delete failed",
  "admin.jurisdictions.unknownError": "Unknown error",
  "admin.jurisdictions.deleteConfirm": "Delete \"{country}\"?",
  "admin.jurisdictions.noResults": "No jurisdictions found.",
  "admin.jurisdictions.modalEdit": "Edit Jurisdiction",
  "admin.jurisdictions.modalCreate": "Add Jurisdiction",
  "admin.jurisdictions.country": "Country *",
  "admin.jurisdictions.entity": "Entity Type *",
  "admin.jurisdictions.price": "Price *",
  "admin.jurisdictions.flagIcon": "Flag Icon (Remix Icon)",
  "admin.jurisdictions.image": "Jurisdiction Image",
  "admin.jurisdictions.sortOrder": "Sort Order",
  "admin.jurisdictions.popularCb": "Popular",
  "admin.jurisdictions.activeCb": "Active",
  "admin.jurisdictions.cancel": "Cancel",
  "admin.jurisdictions.saving": "Saving...",
  "admin.jurisdictions.update": "Update",
  "admin.jurisdictions.create": "Create",
  "admin.jurisdictions.countryPh": "e.g. Germany",
  "admin.jurisdictions.entityPh": "e.g. GmbH / UG",
  "admin.jurisdictions.pricePh": "e.g. Starting from €1,200",

  "admin.siteSettings.loadFailed": "Failed to load settings",
  "admin.siteSettings.loading": "Loading settings...",
  "admin.siteSettings.retry": "Try Again",
  "admin.siteSettings.saved": "Saved!",
  "admin.siteSettings.saveFailed": "Save failed",
  "admin.siteSettings.unknownError": "Unknown error",
  "admin.siteSettings.openLink": "Open Link",
  "admin.siteSettings.saving": "Saving...",
  "admin.siteSettings.save": "Save",
  "admin.siteSettings.settingCount": "settings",
  "admin.siteSettings.urlPlaceholder": "https://...",
  "admin.siteSettings.group.general": "General",
  "admin.siteSettings.group.branding": "Branding",
  "admin.siteSettings.group.seo": "SEO & Meta",
  "admin.siteSettings.group.social": "Social Media",
  "admin.siteSettings.group.contact": "Contact",
  "admin.siteSettings.group.analytics": "Analytics",
};